var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CustomSelect',{attrs:{"size":_vm.size,"options":_vm.options,"active":_vm.active},on:{"change":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }